import Thumbnails from './thumbnails';
export default Thumbnails;